


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: "AIzaSyC5ReOuvJzHuq7PH91mp-7QELpO9uPxlX0",
  authDomain: "house-of-vision-3bff6.firebaseapp.com",
  projectId: "house-of-vision-3bff6",
  storageBucket: "house-of-vision-3bff6.firebasestorage.app",
  messagingSenderId: "518431906537",
  appId: "1:518431906537:web:9e5f7d8176846e05112e78"
};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export